import { FileText, FileEdit } from 'lucide-react';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TYPE_CONFIG = {
  contrat: { label: 'Dossier', color: 'bg-blue-500', icon: FileText },
  avenant: { label: 'Avenant', color: 'bg-purple-500', icon: FileEdit }
};

export const STATUT_CONFIG = {
  en_attente: { label: 'En attente', color: 'bg-amber-500' },
  en_attente_paiement: { label: 'Attente paiement', color: 'bg-orange-500' },
  EN_ATTENTE_VIREMENT: { label: 'Attente virement', color: 'bg-yellow-500' },
  validee: { label: 'Validée', color: 'bg-green-500' },
  paiement_valide: { label: 'Paiement validé', color: 'bg-emerald-500' }
};

export const PAYMENT_METHOD_CONFIG = {
  virement: { label: 'Virement', shortLabel: 'VIR', color: 'bg-blue-600 text-white border-blue-700', icon: 'Landmark' },
  sepa: { label: 'Prélèvement SEPA', shortLabel: 'SEPA', color: 'bg-indigo-600 text-white border-indigo-700', icon: 'Repeat' },
  sepa_debit: { label: 'Prélèvement SEPA', shortLabel: 'SEPA', color: 'bg-indigo-600 text-white border-indigo-700', icon: 'Repeat' },
  prelevement_sepa: { label: 'Prélèvement SEPA', shortLabel: 'SEPA', color: 'bg-indigo-600 text-white border-indigo-700', icon: 'Repeat' },
  carte: { label: 'Carte bancaire', shortLabel: 'CB', color: 'bg-emerald-600 text-white border-emerald-700', icon: 'CreditCard' },
  card: { label: 'Carte bancaire', shortLabel: 'CB', color: 'bg-emerald-600 text-white border-emerald-700', icon: 'CreditCard' },
  cb: { label: 'Carte bancaire', shortLabel: 'CB', color: 'bg-emerald-600 text-white border-emerald-700', icon: 'CreditCard' },
  cheque: { label: 'Chèque', shortLabel: 'CHQ', color: 'bg-amber-600 text-white border-amber-700', icon: 'FileText' },
  especes: { label: 'Espèces', shortLabel: 'ESP', color: 'bg-green-600 text-white border-green-700', icon: 'Banknote' },
  stripe: { label: 'Stripe', shortLabel: 'STR', color: 'bg-violet-600 text-white border-violet-700', icon: 'CreditCard' },
  autre: { label: 'Autre', shortLabel: 'AUT', color: 'bg-gray-600 text-white border-gray-700', icon: 'Euro' }
};

export const getPaymentMethodConfig = (method) => {
  if (!method) return PAYMENT_METHOD_CONFIG.autre;
  const key = method.toLowerCase().replace(/[^a-z_]/g, '');
  return PAYMENT_METHOD_CONFIG[key] || PAYMENT_METHOD_CONFIG.autre;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch { return dateStr; }
};

export const getDaysUntil = (dateStr) => {
  if (!dateStr) return null;
  try {
    const date = new Date(dateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return Math.ceil((date - today) / (1000 * 60 * 60 * 24));
  } catch { return null; }
};

export const calculateNextDueDate = (doc) => {
  if (doc.date_echeance || doc.date_prochaine_echeance) {
    return doc.date_echeance || doc.date_prochaine_echeance;
  }
  if (doc.echeancier && doc.echeancier.length > 0) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const nextEcheance = doc.echeancier.find(e => {
      const echeanceDate = new Date(e.date);
      return echeanceDate >= today && !e.paye;
    });
    if (nextEcheance) return nextEcheance.date;
  }
  if (doc.paiements_partiels && doc.paiements_partiels.length > 0) {
    const lastPayment = doc.paiements_partiels[doc.paiements_partiels.length - 1];
    if (lastPayment.date) {
      const lastDate = new Date(lastPayment.date);
      lastDate.setDate(lastDate.getDate() + 30);
      return lastDate.toISOString().split('T')[0];
    }
  }
  if (doc.date_creation || doc.created_at) {
    const creationDate = new Date(doc.date_creation || doc.created_at);
    creationDate.setDate(creationDate.getDate() + 30);
    return creationDate.toISOString().split('T')[0];
  }
  return null;
};

export const getEcheanceStatus = (dateStr) => {
  const days = getDaysUntil(dateStr);
  if (days === null) return { status: 'unknown', label: 'Non définie', color: 'text-white bg-gray-500' };
  if (days < 0) return { status: 'overdue', label: `En retard (${Math.abs(days)}j)`, color: 'text-white bg-red-600' };
  if (days === 0) return { status: 'today', label: "Aujourd'hui", color: 'text-white bg-orange-600' };
  if (days <= 7) return { status: 'urgent', label: `Dans ${days}j`, color: 'text-white bg-amber-600' };
  if (days <= 30) return { status: 'soon', label: `Dans ${days}j`, color: 'text-white bg-blue-600' };
  return { status: 'ok', label: `Dans ${days}j`, color: 'text-white bg-green-600' };
};

export const paiementsEnregistres = (doc) => (doc?.paiements_partiels || []).filter((p) => !p.is_scheduled && p.statut_encaissement !== 'programme');
